import { NgModule } from 'ng-metadata/core';
import {PagesTitlesService} from "./pagesTitles.service";

@NgModule({
    declarations: [

    ],
    providers: [
        PagesTitlesService

    ],
    imports:[

    ]
})

export class PagesTitlesModule{}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/accessibility/pagesTitles.module.ts